import { useContext } from "react";
import { PopupContext } from "../../context/PopupContext";
import classes from "../../scss/ServiceButton.module.scss";

export default function RequestDemo({ className }) {
  const { openPopup } = useContext(PopupContext);

  const openCalendly = () => openPopup("calendly");

  return (
    <button
      data-content="request demo"
      data-text="request demo"
      className={`${classes.button} ${className}`}
      onClick={openCalendly}
    >
      request demo
    </button>
  );
}
